
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestridesharelawyers",
      function () {
        return require("private-next-pages/bestridesharelawyers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestridesharelawyers"])
      });
    }
  